import { c as _c } from "react/compiler-runtime";
import { useDateTime } from "@hooks/use-date-time";
import { SubscriptionInfoItem } from "@pages/settings/subscription-settings/subscription-info-item";
import { SubscriptionInfoSubtitle } from "@pages/settings/subscription-settings/subscription-info-subtitle";
import { DEFAULT_SUBSCRIPTION_NAME_NO_SUBSCRIPTION } from "@src/constants/subscription-constants";
import { activeSubscriptionSelector, upcomingXgSubscriptionSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { useMemo } from "react";
/** Custom hook to return subscription settings props for subscription page */
export function useSubscriptionSettings() {
  const $ = _c(41);
  const {
    formatDate
  } = useDateTime();
  const activeSubscription = useAppSelector(activeSubscriptionSelector);
  const upcomingSubscription = useAppSelector(upcomingXgSubscriptionSelector);
  let t0;
  bb0: {
    if (!activeSubscription) {
      let t1;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
      } else {
        t1 = $[0];
      }
      t0 = t1;
      break bb0;
    }
    let t1;
    if ($[1] !== activeSubscription.label) {
      t1 = <SubscriptionInfoSubtitle name={activeSubscription.label} />;
      $[1] = activeSubscription.label;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    const t2 = activeSubscription.label ?? DEFAULT_SUBSCRIPTION_NAME_NO_SUBSCRIPTION;
    const t3 = !!activeSubscription.label;
    let t4;
    if ($[3] !== t2 || $[4] !== t3) {
      t4 = {
        label: "Subscription plan",
        shouldAddRightPadding: true,
        content: <SubscriptionInfoItem text={t2} shouldNotTranslate={t3} />
      };
      $[3] = t2;
      $[4] = t3;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    const t5 = !activeSubscription.endDate;
    let t6;
    if ($[6] !== activeSubscription.endDate || $[7] !== formatDate) {
      t6 = activeSubscription.endDate ? formatDate(activeSubscription.endDate) : "";
      $[6] = activeSubscription.endDate;
      $[7] = formatDate;
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    let t7;
    if ($[9] !== t6) {
      t7 = <SubscriptionInfoItem text={t6} shouldNotTranslate={true} />;
      $[9] = t6;
      $[10] = t7;
    } else {
      t7 = $[10];
    }
    let t8;
    if ($[11] !== t5 || $[12] !== t7) {
      t8 = {
        label: "End date",
        shouldAddRightPadding: true,
        isHidden: t5,
        content: t7
      };
      $[11] = t5;
      $[12] = t7;
      $[13] = t8;
    } else {
      t8 = $[13];
    }
    let t9;
    if ($[14] !== t4 || $[15] !== t8) {
      t9 = [t4, t8];
      $[14] = t4;
      $[15] = t8;
      $[16] = t9;
    } else {
      t9 = $[16];
    }
    let t10;
    if ($[17] !== t1 || $[18] !== t9) {
      t10 = [{
        title: "Current plan",
        subtitle: t1,
        items: t9
      }];
      $[17] = t1;
      $[18] = t9;
      $[19] = t10;
    } else {
      t10 = $[19];
    }
    t0 = t10;
  }
  const subscriptionSectionProps = t0;
  let t1;
  bb1: {
    if (!upcomingSubscription) {
      let t2;
      if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [];
        $[20] = t2;
      } else {
        t2 = $[20];
      }
      t1 = t2;
      break bb1;
    }
    const t2 = upcomingSubscription.label ?? DEFAULT_SUBSCRIPTION_NAME_NO_SUBSCRIPTION;
    const t3 = !!upcomingSubscription.label;
    let t4;
    if ($[21] !== t2 || $[22] !== t3) {
      t4 = {
        label: "Subscription plan",
        shouldAddRightPadding: true,
        content: <SubscriptionInfoItem text={t2} shouldNotTranslate={t3} />
      };
      $[21] = t2;
      $[22] = t3;
      $[23] = t4;
    } else {
      t4 = $[23];
    }
    let t5;
    if ($[24] !== formatDate || $[25] !== upcomingSubscription.startDate) {
      t5 = formatDate(upcomingSubscription.startDate);
      $[24] = formatDate;
      $[25] = upcomingSubscription.startDate;
      $[26] = t5;
    } else {
      t5 = $[26];
    }
    let t6;
    if ($[27] !== t5) {
      t6 = {
        label: "Start date",
        shouldAddRightPadding: true,
        content: <SubscriptionInfoItem text={t5} shouldNotTranslate={true} />
      };
      $[27] = t5;
      $[28] = t6;
    } else {
      t6 = $[28];
    }
    let t7;
    if ($[29] !== formatDate || $[30] !== upcomingSubscription.endDate) {
      t7 = formatDate(upcomingSubscription.endDate);
      $[29] = formatDate;
      $[30] = upcomingSubscription.endDate;
      $[31] = t7;
    } else {
      t7 = $[31];
    }
    let t8;
    if ($[32] !== t7) {
      t8 = {
        label: "End date",
        shouldAddRightPadding: true,
        content: <SubscriptionInfoItem text={t7} shouldNotTranslate={true} />
      };
      $[32] = t7;
      $[33] = t8;
    } else {
      t8 = $[33];
    }
    let t9;
    if ($[34] !== t4 || $[35] !== t6 || $[36] !== t8) {
      t9 = [{
        title: "Upcoming plan",
        subtitle: "This plan takes over once your current plan ends.",
        items: [t4, t6, t8]
      }];
      $[34] = t4;
      $[35] = t6;
      $[36] = t8;
      $[37] = t9;
    } else {
      t9 = $[37];
    }
    t1 = t9;
  }
  const upcomingPlanSectionProps = t1;
  let t2;
  if ($[38] !== subscriptionSectionProps || $[39] !== upcomingPlanSectionProps) {
    t2 = {
      subscriptionSectionProps,
      upcomingPlanSectionProps
    };
    $[38] = subscriptionSectionProps;
    $[39] = upcomingPlanSectionProps;
    $[40] = t2;
  } else {
    t2 = $[40];
  }
  return t2;
}